export enum TermsStatus {
    Active = "active",
    Passive = "passive"
}

export default interface Terms {
    _id: string;
    name: string;
    version: string;
    status: TermsStatus;
    title: string;
    summary: string;
    notificationText: string;
}
